import type { AuthContextType, ExternalListing } from '../contexts';

export const getOrgLogoSrcFromAuth: (
  auth: AuthContextType['auth'],
) => string = auth => {
  const {
    address,
    location: authLocation,
    org: { addresses, logoUrl },
  } = auth;

  const currLocationLogo =
    addresses?.[Number(authLocation)]?.[Number(address)]?.logo;
  const orgLogo = logoUrl;

  return currLocationLogo || orgLogo;
};

export const getOrgLogoSrcFromListing: (
  listing: ExternalListing,
) => string = listing => {
  // ExternalAuthContext
  const currentLocationLogo =
    listing.address &&
    listing.org.addresses?.[listing.address]?.[
      parseInt(listing.location?.toString(), 10)
    ]?.logo;

  return currentLocationLogo || listing.org.logoUrl;
};
